const translations = {
    searchPlaceholder: 'Search drones by name or serial...'
};

export default translations;
